/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { LocationList } from 'src/app/common/fancy-firebase/services/factories';
import { Location } from '@touchplan/common';

export class LocationsApi extends FancyActionableFirebase<Location, FancyAction, LocationList> {
	constructor(public data: LocationList) {
		super(data);
	}
}
